// Third-party
import React, { ReactElement } from 'react';
import classNames from 'classnames';
import Nullable from '@/types/nullable';

type Props = {
  className?: string;
  selected: Nullable<string | number>;
  onChange: (value: any) => void;
  onKeyDown?: (event: React.KeyboardEvent, orientation: Props['orientation']) => void;
  children: ReactElement | ReactElement[];
  dark?: boolean;
  tabStyle?: boolean;
  orientation?: 'horizontal' | 'vertical';
  darkerBackground?: boolean;
  disabled?: boolean;
  role?: React.AriaRole;
};

const SegmentedControl = ({
  className,
  selected = null,
  onChange = () => {},
  onKeyDown,
  dark,
  children,
  tabStyle,
  orientation = 'horizontal',
  darkerBackground,
  disabled,
  role,
}: Props) => {
  const onItemClick = (value: any) => {
    if (selected !== value) {
      onChange(value);
    }
  };

  const classes = classNames(`segmented-control ${orientation}`, className, {
    dark,
    disabled,
    'tab-style': tabStyle,
    'darker-bg': darkerBackground,
  });

  return (
    <ul className={classes} role={role} aria-orientation={orientation} onKeyDown={event => onKeyDown?.(event, orientation)}>
      {React.Children.map(children, child =>
        React.cloneElement(child, {
          className: classNames({ selected: selected === child.props.value }),
          onClick: onItemClick,
        }),
      )}
    </ul>
  );
};

export default SegmentedControl;
